import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const loc = useLocation();

  if (user === null) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ background: "#f7f5f0" }}
        data-testid="auth-loading"
      >
        <Loader2 className="w-6 h-6 animate-spin text-stone-500" strokeWidth={1.5} />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }
  return children;
}
